<template>
	<ho-modal-dialog
		:headerText="localization.t(editMode
			? 'administration.organizations.edit-dialog-title'
			: 'administration.organizations.create-dialog-title')"
		:hide-footer="true"
		:width="480"
		@onCancel="handleModalCancel"
	>
		<template v-slot:body>
			<create-organization-form :loading="loading" :edit-mode="editMode" :organization-data="organizationData"
				@on-close="handleFormClose" />
		</template>
	</ho-modal-dialog>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import HoModalDialog from "@/components/modal/ho-modal-dialog.vue";
import CreateOrganizationForm from "./createOrganizationForm/index.vue";
import IOrganization, {
	ICreateOrganizationData,
	IUpdateOrganizationData,
} from "@/interfaces/organizations/iOrganization";

defineProps({
	loading: Boolean,
	editMode: Boolean,
	organizationData: {
		type: Object as () => IOrganization,
	},
});

const emit = defineEmits(["onSubmit", "onCancel"]);

const localization = useI18n();

const handleFormClose = (data?: ICreateOrganizationData | IUpdateOrganizationData) => {
	data ? emit("onSubmit", data) : emit("onCancel");
};

const handleModalCancel = () => {
	emit("onCancel");
};
</script>
